export const FILTER_OWNERS = 'owners';
export const FILTER_PARTNER_COMPANIES = 'partnerCompanies';
export const FILTER_NETWORKS = 'networks';
export const FILTER_LAST_UPDATED = 'lastUpdated';

export const FILTERS_DEPENDENCIES = {
  [FILTER_OWNERS]: [FILTER_PARTNER_COMPANIES],
};

export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_OWNER = 'owner';
export const COLUMN_PARTNER_COMPANY = 'partnerCompany';
export const COLUMN_AFFILIATES = 'affiliates';
export const COLUMN_NETWORKS = 'networks';
export const COLUMN_START_DATE = 'startDate';
export const COLUMN_LAST_UPDATED_BY = 'lastUpdatedBy';
export const COLUMN_LAST_UPDATED_DATE = 'lastUpdatedDate';
export const COLUMN_CREATED_DATE = 'createdDate';

export const ACTION_EDIT = 'Edit';
export const ACTION_DELETE = 'Delete';
